import { customAlphabet } from "nanoid";

// URL に出すため、紛らわしい文字を除いたアルファベットを使用する。
// 12 文字あれば衝突確率は十分低い（10^21 通り）。
const alphabet = "23456789abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ";
const generate = customAlphabet(alphabet, 12);

/**
 * 新規キャンバス ID を生成する。
 */
export function generateCanvasId(): string {
  return generate();
}

/**
 * URL のキャンバス ID として有効な文字列か判定する。
 */
export function isValidCanvasId(value: string): boolean {
  return /^[A-Za-z0-9_-]{6,32}$/.test(value);
}
